import { Tab, Tabs, Typography } from "@mui/material";
import { FilesProvider } from "./components/fileContext";
import { FilesDisplay } from "./components/fileDisplay";
import { FilesAddButton, FilesUploadButton } from "./components/fileUpload";
import { SelectTable } from "./components/selectTable";
import React, { useContext, useState } from "react";
import CSVFilesLogs from "./components/logs";
import { env } from "../../env";
import { AuthContext } from "../auth/authContext";

const url = env === 'prod'
  ? 'https://us-central1-etl-directories1.cloudfunctions.net/cf_run_dedup'
  : `http://localhost:8080`

export const CSVUploaderPage = () => {
  const [value, setValue] = useState(0);
  const auth = useContext(AuthContext);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const runDedup = async () => {
    if (window.confirm("This action might generate cost on BigQuery. It also might take a while to run. Are you sure you want to proceed?")) {
      const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password: auth.password }) });
      if (response.ok) {
        alert(await response.text() || 'Dedup procedure ran successfully.')
      };
    };
  };

  return <FilesProvider>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '25px', justifyContent: 'start', paddingTop: '15px', height: '95%', alignItems: 'center' }}>
      <Tabs value={value} onChange={handleChange} sx={{ marginTop: '-35px' }}>
        <Tab label="Upload" />
        <Tab label="Logs" />
      </Tabs>

      {value === 0
        ? <>
          <div className='Files' style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '80%', gap: '25px', justifyContent: 'center', alignItems: 'start' }}>
            <FilesDisplay />
            <FilesAddButton />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '25px', justifyContent: 'center', alignItems: 'center' }}>
            <SelectTable />
            <FilesUploadButton />
          </div>
          <Typography onClick={() => runDedup()} sx={{ fontSize: '10pt', cursor: 'pointer', color: '#1976d2' }}>Click here to manually run the deduplication procedure.</Typography>
        </>
        : <CSVFilesLogs />
      }

    </div>
  </FilesProvider >
};